/**
 * Start swiper instances
 */

import Swiper from 'swiper/dist/js/swiper.min';

export const initSwiper = function(md){

    let speed = 750;
    if($(".image-slider .swiper-slide").length > 2 ) {

        let bannerSwiperBack = new Swiper(".swiper-container--base", {
            direction: 'horizontal',
            speed: speed,
            autoplay: false,
            loop: true,
            keyboardControl: false,
        });

        let bannerSwiperOverlay = new Swiper(".swiper-container--overlay", {
            slidesPerView: 1,
            spaceBetween: 0,
            direction: 'horizontal',
            speed: speed,
            loop: true,
            keyboardControl: true,
            autoplay: {
                delay: 5000
            },
            effect: 'slide',
            navigation: {
                nextEl: '.image-slider__nav-button--next',
                prevEl: '.image-slider__nav-button--prev',
            },
            control: bannerSwiperBack,
            by: 'container',


            pagination: {
                el: '.image-slider__swiper-paging',
                type: 'bullets',
                clickable: true,
                renderBullet: function paginationBulletRender(index, className) {
                    index = index+1;
                    if( index < 10 ){
                        index = '0'+index;
                    }
                    return '<button class="'+className+'">' + index + '</button>';
                },

            },

        });

        bannerSwiperOverlay.controller.control = bannerSwiperBack;
        bannerSwiperBack.controller.control = bannerSwiperOverlay;
        bannerSwiperOverlay.autoplay.start();

        // gallery swiper
        speed = 750;
        if($(".swiper-container--gallery .swiper-slide").length > 2 ) {

            let gallerySwiper = new Swiper(".swiper-container--gallery", {
                direction: 'horizontal',
                slidesPerView: 'auto',
                /* loopedSlides: 8, */
                spaceBetween: 30,
                speed: speed,
                autoplay: true,
                loop: true,
                /* effect: 'coverflow', */
                keyboardControl: true
            });

        }
    }

    if($(".instagram-slider .swiper-slide").length > 1 ) {
        let bannerSwiper = new Swiper(".instagram-slider", {
            slidesPerView: 4,
            spaceBetween: 30,
            speed: 2000,
            autoplay: false,
            /*
             autoplay: {
             delay: 5000
             },
             */
            loop: false,
            navigation: {
                nextEl: '.instagram-slider__nav-button--next',
                prevEl: '.instagram-slider__nav-button--prev',
            },
            breakpoints: {
                640: {
                    slidesPerView: 2
                },
                1024: {
                    slidesPerView: 3
                },
                1280: {
                    slidesPerView: 4
                }
            }
        });
        bannerSwiper.autoplay.start();
    }

};




